import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const useCustomTransactionTwoFlag = () =>
  useBooleanFlagValue('custom-transaction-two', false);
